export default {"src":"/_next/static/media/_download.92becd03.svg","height":24,"width":24};